import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signUpWithEmail } from '../../api/SupabaseApi';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const Signup = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showVerifyPopup, setShowVerifyPopup] = useState(false);
  const [maskedEmail, setMaskedEmail] = useState('');
  const navigate = useNavigate();

  // Helper to mask email as per requirements
  const maskEmail = (email) => {
    const [local, domain] = email.split('@');
    if (local.length <= 5) {
      // fallback for short emails
      return local[0] + '*'.repeat(local.length - 1) + '@' + domain;
    }
    const first2 = local.slice(0, 2);
    const last3 = local.slice(-3);
    const masked = first2 + '*'.repeat(local.length - 5) + last3 + '@' + domain;
    return masked;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { data, error } = await signUpWithEmail(email, password, name);
    console.log('data', {data, error})
    setLoading(false);
    if (error) {
      setError(error.message);
    } else if (data && data.user?.user_metadata?.email_verified===false) {
      setMaskedEmail(maskEmail(email));
      setShowVerifyPopup(true);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      {/* Popup for email verification */}
      {showVerifyPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-surface p-6 rounded-xl shadow-lg w-full max-w-sm border border-border text-center">
            <h3 className="text-xl font-bold mb-4">Please confirm your email</h3>
            <p className="mb-4">We sent a verification link to your email:</p>
            <div className="font-mono text-primary mb-4">{maskedEmail}</div>
            <Button onClick={() => setShowVerifyPopup(false)} variant="primary">Close</Button>
          </div>
        </div>
      )}
      <form onSubmit={handleSubmit} className="bg-surface p-8 rounded-xl shadow-lg w-full max-w-md border border-border">
        <h2 className="text-2xl font-bold mb-6 text-center">Sign Up</h2>
        {error && <div className="mb-4 text-error text-sm text-center">{error}</div>}
        <div className="mb-4">
          <label className="block mb-1 text-text-primary">Name</label>
          <input
            type="text"
            className="w-full px-3 py-2 border border-border rounded-lg bg-background text-text-primary"
            value={name}
            onChange={e => setName(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
          <label className="block mb-1 text-text-primary">Email</label>
          <input
            type="email"
            className="w-full px-3 py-2 border border-border rounded-lg bg-background text-text-primary"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="mb-6">
          <label className="block mb-1 text-text-primary">Password</label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              className="w-full px-3 py-2 pr-10 border border-border rounded-lg bg-background text-text-primary"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-text-secondary hover:text-text-primary transition-colors"
              onClick={() => setShowPassword(!showPassword)}
            >
              <Icon name={showPassword ? "EyeOff" : "Eye"} size={18} />
            </button>
          </div>
        </div>
        <Button type="submit" variant="primary" size="md" className="w-full" loading={loading}>
          Sign Up
        </Button>
        <div className="mt-4 text-center text-sm">
          Already have an account?{' '}
          <button type="button" className="text-primary underline" onClick={() => navigate('/login')}>
            Login
          </button>
        </div>
      </form>
    </div>
  );
};

export default Signup; 